export default __webpack_public_path__ + "static/media/mindmap_alzheimer.891fe30a.png";